import React from "react";
import {DispatchOrder} from "../../types/DispatchOrder";
import {DispatchOrderListRow} from "../dispatch-orders/DispatchOrderListRow";

interface RecentDispatchOrdersListProps {
    dispatchOrders: DispatchOrder[];
    onClickRow: (dispatchOrderId: number) => void;
    onClickViewAll: () => void;
}

export let RecentDispatchOrdersList = function (props: RecentDispatchOrdersListProps) {
    return (
        <div className="recent-dispatch-orders">
            <div className="recent-dispatch-orders-header">
                <div className="recent-dispatch-orders-title">Recent Dispatch Orders</div>
                <div className="recent-dispatch-orders-view-all" onClick={props.onClickViewAll}>
                    View all
                    <img className="recent-dispatch-orders-view-all-chevron" src="/static/images/chevron-right-green.svg" alt="View all"/>
                </div>
            </div>
            {props.dispatchOrders.length === 0 ? (
                <div className="recent-dispatch-orders-empty">No dispatch orders found.</div>
            ) : (
                <div className="recent-dispatch-orders-rows">
                    {props.dispatchOrders.map((dispatchOrder) => (
                        <DispatchOrderListRow
                            key={dispatchOrder.id}
                            dispatchOrder={dispatchOrder}
                            onClickDispatchOrderListRow={() => props.onClickRow(dispatchOrder.id)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};
